import * as api from '@/api/role'

export let state = {
  roleList: []
}

export let mutations = {
  setRoleList: (state, payload) => state.roleList = payload,
}

export let actions = {

  list: ({ commit }) => new Promise((resolve, reject) => {
    api.list(response => {
      commit('setRoleList', response.data)
      resolve()
    }, reject)
  }),

}